import { render, staticRenderFns } from "./AnalyticsPage.vue?vue&type=template&id=15816ac6"
import script from "./AnalyticsPage.vue?vue&type=script&lang=js"
export * from "./AnalyticsPage.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsPage.vue?vue&type=style&index=0&id=15816ac6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports